import { useCurrentUser } from 'hooks/auth';
import React from 'react';

import DashboardV1 from './dashboard-v1/Dashboard';
import DashboardV2 from './dashboard-v2/Dashboard';

const Dashboard = () => {
  const { getData } = useCurrentUser();
  const region = getData()?.data?.currentCompanyUser?.company?.region;

  if (region === 'US') {
    return <DashboardV2 />;
  }

  return <DashboardV1 />;
};

export default Dashboard;
